export default {"src":"/_next/static/media/redact-icon.36b8b1c3.svg","height":62,"width":72,"blurWidth":0,"blurHeight":0};